import { StatusBar } from 'expo-status-bar';
import { Platform, StyleSheet, Text, TextInput, View } from 'react-native';
import Button from './Button.jsx';
import Header from './Header.jsx';
import StatModal from './StatModal.jsx';
import React, { useState, useContext, useEffect, useRef } from "react";
import {
    collection,
    getDocs,
} from "firebase/firestore";
import { db } from './firebaseConfig';

// Get a list of words from your database
async function getRandomWords() {
    const wordsCollection = collection(db, 'words');
    const wordSnapshot = await getDocs(wordsCollection);
    const words = [];

    wordSnapshot.forEach((doc) => {
        const w = doc.data();
        words.push(w.word);
    });

    const wordListLength = words.length;
    const randomIndex = Math.floor(Math.random() * wordListLength);

    return 'alone';
    return words[randomIndex].toLowerCase();
}

interface WordHash {
    [key: string]: number
}

function processWord(word: string | undefined) : WordHash | null {

    if (typeof word === 'undefined') {
        return null;
    }

    const wordHash: WordHash = {};

    // process word
    // {
    //     'a': 1,
    //     'p': 2,
    //     'l': 1,
    //     'e': 1,
    // }
    for (let w of word) {
        wordHash[w] = wordHash[w] ? wordHash[w] = wordHash[w] + 1 : 1;
    }

    return wordHash;
}

const NUM_GUESSES = 6;
const WORD_LENGTH = 5;

export default function App() {
    
    let [word, setWord] = useState<string | undefined>();
    let [wordHash, setWordHash] = useState<WordHash>({});
    let [guesses, setGuesses] = useState(Array(NUM_GUESSES).fill(null));
    let [currentGuess, setCurrentGuess] = useState('');
    let [gameOver, setGameOver] = useState(false);
    let keyboardKeys = useRef({
        keys: [
            [
                {
                    key: 'q',
                },
                {
                    key: 'w',
                },
                {
                    key: 'e',
                },
                {
                    key: 'r',
                },
                {
                    key: 't',
                },
                {
                    key: 'y',
                },
                {
                    key: 'u',
                },
                {
                    key: 'i',
                },
                {
                    key: 'o',
                },
                {
                    key: 'p',
                },
            ],
            [
                {
                    key: 'a',
                },
                {
                    key: 's',
                },
                {
                    key: 'd',
                },
                {
                    key: 'f',
                },
                {
                    key: 'g',
                },
                {
                    key: 'h',
                },
                {
                    key: 'j',
                },
                {
                    key: 'k',
                },
                {
                    key: 'l',
                },
            ],
            [
                {
                    key: 'Enter',
                    status: 'Enter',
                },                
                {
                    key: 'z',
                },
                {
                    key: 'x',
                },
                {
                    key: 'c',
                },
                {
                    key: 'v',
                },
                {
                    key: 'b',
                },
                {
                    key: 'n',
                },
                {
                    key: 'm',
                },
                {
                    key: 'Backspace',
                    keyDisplay: 'DEL',
                    status: 'Backspace',
                },
            ]
        ]
    });
    const [modalVisible, setModalVisible] = useState(false);

    // initial load data for the screen
    useEffect(() => {

        // getRandomWords().then((w) => {
        //     setWord(w);
        //     setWordHash(processWord(w));
        // });

        setWord('alone');
        setWordHash(processWord('alone'));

    }, []);

    useEffect(() => {

        if (word === null) return;

        const onKeyDown = (event) => {
            if (guesses[NUM_GUESSES - 1] != null || guesses.includes(word)) {
                return;
            }

            const charCode = event.key.toLowerCase().charCodeAt(0);
            const isLetter = 
                event.key.length === 1 &&
                charCode >= 'a'.charCodeAt(0) &&
                charCode <= 'z'.charCodeAt(0);

            setCurrentGuess((prevGuess) => {

                if (event.key === 'Backspace') {
                    return prevGuess.slice(0, -1);
                } else if (event.key === 'Enter' && prevGuess.length === WORD_LENGTH) {
                    const currentGuessIndex = guesses.findIndex((guess) => {
                        return guess === null;
                    });

                    const guessesClone = [...guesses];
                    guessesClone[currentGuessIndex] = prevGuess;
                    setGuesses(guessesClone);

                    return ''; // return to reset currentGuess
                } else if (prevGuess.length < WORD_LENGTH && isLetter) {
                    return prevGuess + event.key.toLowerCase();
                }

                return prevGuess;
            });
        }

        if (Platform.OS === 'web') {
            window.addEventListener('keydown', onKeyDown);
        }

        return () => {
            if (Platform.OS === 'web') {
                window.removeEventListener('keydown', onKeyDown);
            }
        }

    }, [word, guesses]);

    useEffect(() => {
        if (guesses[NUM_GUESSES - 1] != null || guesses.includes(word)) {
            setGameOver(true);
            setModalVisible(true);
        }
    }, [guesses]);

    const currentGuessIndex = guesses.findIndex((guess) => {
        return guess === null;
    });

    if (word === null) return null;

    return (
        <React.StrictMode>
            <View style={styles.container}>
                <Header setModalVisible={setModalVisible}/>
                <StatModal
                    modalVisible={modalVisible}
                    setModalVisible={setModalVisible}
                    word={word}
                    gameOver={gameOver}
                    won={guesses.includes(word)}
                />
                {
                    guesses.map((guess, i) => {
                        return (
                            <GuessLine
                                key={i}
                                guess={(i === currentGuessIndex ? currentGuess : guess ?? '').padEnd(WORD_LENGTH)}
                                word={word}
                                wordHash={wordHash}
                                keyboardKeys={keyboardKeys}
                                isFinal={currentGuessIndex > i || currentGuessIndex === -1}
                            /> 
                        );
                    })
                }
                <Keyboard keyboardKeys={keyboardKeys} />

            </View>
        </React.StrictMode>
    );
}


function Keyboard({keyboardKeys}) {
    return <View style={styles.keyboard}>
        {keyboardKeys.current.keys.map((keyboardRow, i) => {

            return <View key={i} style={styles.keyboardRow}> 
                    
                {keyboardRow.map((keyObj, j) => {

                    let className = 'keyboardKey' + keyObj.status;

                    return (
                        <Button
                            style={styles[className]}
                            key={j}
                            title={keyObj.keyDisplay ? keyObj.keyDisplay : keyObj.key}
                            onPress={(event) => {
                                window.dispatchEvent(new KeyboardEvent('keydown', {'key': keyObj.key}));
                                event.currentTarget.blur()
                            }}
                        />
                    );

                })}

            </View>
        })}
    </View>
}

function GuessLine({guess, word, wordHash, keyboardKeys, isFinal}) {

    let processKeyboardKeys = (key, status) => {
        for (let keyboardRow of keyboardKeys.current.keys) {
            for (let keyObj of keyboardRow) {
                if (key === keyObj.key) {

                    if (keyObj.status === undefined ||
                        (keyObj.status === 'Close' && status == 'Correct')
                    ) {
                        keyObj.status = status;
                    }

                }
            }
        }
    }

    let wordHashClone = {...wordHash};

    if (word) {
        // remove all the valid count of letter in wordHash, so we don't get duplicate yellow tile
        for (let i in guess) {
            if (guess[i] === word.charAt(i)) {
                wordHashClone[guess[i]] = wordHashClone[guess[i]] - 1;
            }
        }
    }

    return (
        <View style={styles.guessLine}>
            {
                guess.split('').map((char, i) => {
                    let className = 'tile';
                    let extraClass = '';

                    if (isFinal) {
                        if (char === word[i]) {
                            extraClass = 'Correct';
                        } else if (word.includes(char) && wordHashClone[char] > 0) {
                            extraClass = 'Close';
                            wordHashClone[char] = wordHashClone[char] - 1;
                        } else {
                            extraClass = 'Absent';
                        }

                        processKeyboardKeys(char, extraClass);
                        className += extraClass;
                    }

                    return <View 
                        style={[styles.tile, styles[className]]}
                        key={i}
                    >
                        <Text style={styles.tileText}>{char}</Text>
                    </View>
                })
            }
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        margin: 'auto'
    },
    guessLine: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
    tile: {
        borderRadius: 4,
        borderWidth: 1,
        margin: 5,
        minHeight: 55,
        minWidth: 55,
        justifyContent: 'center',
        alignItems: 'center',
        borderColor: 'gray',
    },
    tileText: {
        fontSize: 30,
        textTransform: 'uppercase',
    },
    tileCorrect: {
        border: 0,
        backgroundColor: '#53BC4A',
        textShadowColor: 'rgba(0, 0, 0, 0.25)',
        textShadowRadius: 5
    },
    tileClose: {
        border: 0,
        backgroundColor: '#FEE49D',
        textShadowColor: 'rgba(0, 0, 0, 0.25)',
        textShadowRadius: 5
    },
    tileAbsent: {
        border: 0,
        backgroundColor: '#808080',
        textShadowColor: 'rgba(0, 0, 0, 0.25)',
        textShadowRadius: 5
    },
    keyboard: {
        marginTop: 20,
    },
    keyboardRow: {
        flexDirection: "row",
        justifyContent: 'center',
        gap: 5,
        margin: 5,
        textTransform: 'uppercase',
    },
    keyboardKeyEnter: {
        width: 70,
    },
    keyboardKeyBackspace: {
        width: 50,
    },
    keyboardKeyCorrect: {
        backgroundColor: '#53BC4A',
    },
    keyboardKeyClose: {
        backgroundColor: '#FEE49D',
    },
    keyboardKeyAbsent: {
        backgroundColor: '#808080',
    },

});
